// import GlobeEuropeAfricaIcon from '@heroicons/react/24/solid/GlobeEuropeAfricaIcon';
import { Grid, 
  // InputAdornment, SvgIcon 
} from '@mui/material';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import { useEffect, useState } from 'react';

import {
  gridSize,
  gridSizeMdLg12,
  // gridSizeMdLg12,
  // gridSizeMdLg6,
  texto,
  useCheckPermissionsArray,
  // useLoaders,
  useMapComponent,
} from '@/shared';
import { useFetchAllNodes, useFetchOLTs } from '@/shared/actions/erp';
// import { IconBtnModalMapComponent } from '@/shared/components/erp';
import {
  CustomAutocomplete,
  // CustomCircularPorgress,
  // CustomNumberTextField,
  // CustomNumberTextField,
  CustomTextArea,
  CustomTextField,
  CustomTextFieldNoForm,
  SingleIconButton,
  // TabTextLabel,
} from '@/shared/components/ui';
import { SAVE_OT_PERMISSIONS_ACTIVACION } from '@/shared/constants/form-permissions';

import { useFetchRouters } from '@/store/erp';
import { useUiConfirmModalStore, useUiStore } from '@/store/ui';
import { OrdenTrabajo, AlertSeverityEnum, Naps, Nodo, OLT, Router, PuertoNap } from '@/shared/interfaces';
// TipoInstalacion,
// import { RenderFotosEntradaSalida } from '@/erp/tecnico/orden-trabajo/shared/components';
// import { useTypeInstalation } from '@/store/erp/system-settings/type-instalation';
import { useActivacionStore } from '@/store/erp/operaciones';
import { CustomAlertCard } from '@/shared/components/ui/Alerts';

export type ActivacionInstaOTActiDataFormTabProps = {
  // form: UseFormReturn<SaveFormDataActivacionInstallPendingOT>;
  form: any;
  ordenTrabajo: OrdenTrabajo;
  isUpdatingPort?: boolean;
  isOnlyView?: boolean;
};

const ActivacionInstaOTActiDataFormTab: React.FC<
  ActivacionInstaOTActiDataFormTabProps
> = ({ form, ordenTrabajo, isUpdatingPort = false, isOnlyView = false }) => {
  useCheckPermissionsArray(SAVE_OT_PERMISSIONS_ACTIVACION);

  const { errors } = form.formState;
  // const shrink = true;

  ///* local state ------------------------
  const [isResetForm, setIsResetForm] = useState(false);

  ///* global state -----------------------
  // const typInstalation = useTypeInstalation((s) => s.typInstalation);
  // const isLoadingTypeInstalation = useTypeInstalation(
  //   (s) => s.isLoadingTypeInstalation
  // );

  const setConfirmDialog = useUiConfirmModalStore(s => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    s => s.setConfirmDialogIsOpen
  );
  const canChangeNap = useActivacionStore(s => s.canChangeNap);
  const canChangeNodeOLT = useActivacionStore(s => s.canChangeNodeOLT);
  const setCanChangeNap = useActivacionStore(s => s.setCanChangeNap);
  const setCanChangeNodeOLT = useActivacionStore(s => s.setCanChangeNodeOLT);
  const setAlert = useUiStore(s => s.setAlert);

  ///* form ------------------------
  const watchedNode = form.watch('nodo');
  // const watchedOlt = form.watch('olt');
  const watchedRawNap: Naps = form.watch('rawNap');
  const watchedPort = form.watch('puerto');

  // map ------------------------
  const {
    // Map,
    // latLng,
    // setLatLng,
    isLoadingNapsByCity,
    // isRefetchingNapsByCity,
    napsByCity,
    // setCurrentCoordenadas,
  } = useMapComponent({
    form,
    currentCity: '', // replaced by coordenadasCliente
    distanciaNapKey: 'distancia',
    coordenadasCliente: form?.getValues()?.coordenadas || '',
    enabledFetchNaps: !!watchedNode,
    selectedNode: watchedNode,
  });

  ///* fetch data ------------------------
  // const {
  //   data: napsPagingRes,
  //   isLoading: isLoadingNaps,
  //   isRefetching: isRefetchingNaps,
  // } = useFetchAllNaps({
  //   params: {
  //     page_size: 450,
  //     lat: form?.getValues()?.coordenadas?.split(',')[0],
  //     lng: form?.getValues()?.coordenadas?.split(',')[1],
  //   },
  // });

  const {
    data: nodosByZona,
    isLoading: isLoadingNodosByZona,
    // isRefetching: isRefetchingNodosByZona,
  } = useFetchAllNodes({
    enabled: !!ordenTrabajo?.id_orden_trabajo,
    params: {
      page_size: 700,
      // zona: ordenTrabajo?.zona,
    },
  });
  const {
    data: oltsPagingRes,
    isLoading: isLoadingOLTs,
    isRefetching: isRefetchingOLTs,
  } = useFetchOLTs({
    enabled: !!watchedNode,
    params: {
      page_size: 700,
      // nodo: watchedNode,
    },
  });
  const {
    data: routesrPagingRes,
    isLoading: isLoadingRouters,
    isRefetching: isRefetchingRouters,
  } = useFetchRouters(
    {
      page_size: 700,
      // nodo: watchedNode,
    },
    !!watchedNode
  );

  ///* effects ------------------------
  useEffect(() => {
    if (isResetForm) return;
    if (
      !ordenTrabajo?.id_orden_trabajo ||
      isLoadingNapsByCity ||
      // isRefetchingNapsByCity ||
      isLoadingNodosByZona 
      // isRefetchingNodosByZona
    )
      return;

    form.reset({
      ...form.getValues(),
      nodo: ordenTrabajo?.nodo || form.getValues()?.nodo || '',
      olt: ordenTrabajo?.olt || form.getValues()?.olt || '',
      nap: ordenTrabajo?.nap || form.getValues()?.nap || '',
      distancia: ordenTrabajo?.agendamiento_data?.distancia || '',
      puerto: ordenTrabajo?.puerto  || form.getValues()?.puerto || '',
    });
    setIsResetForm(true);
  }, [
    ordenTrabajo?.id_orden_trabajo,
    // isLoadingNapsByCity,
    // isRefetchingNapsByCity,
    // isResetForm,
  ]);

  // // alerts
  // olts
  useEffect(() => {
    if (isLoadingOLTs || isRefetchingOLTs) return;

    !oltsPagingRes?.data?.data?.length &&
      setAlert(
        true,
        'No se encontraron OLTs para el Nodo seleccionado',
        AlertSeverityEnum.warning
      );
  }, [isLoadingOLTs, 
    // isRefetchingOLTs, 
    oltsPagingRes]);
  // routers
  useEffect(() => {
    if (isLoadingRouters || isRefetchingRouters) return;

    !routesrPagingRes?.data?.data?.length &&
      setAlert(
        true,
        'No se encontraron Routers para el Nodo seleccionado',
        AlertSeverityEnum.warning
      );
  }, [isLoadingRouters, 
    // isRefetchingRouters, 
    routesrPagingRes]);

  // const isLoadingNodoNaps =
  //   isLoadingNapsByCity ||
  //   isRefetchingNapsByCity ||
  //   isLoadingNodosByZona ||
  //   isRefetchingNodosByZona ||
  //   isLoadingOLTs ||
  //   isRefetchingOLTs ||
  //   isRefetchingRouters ||
  //   isLoadingRouters;

  // useLoaders(isLoadingNodoNaps);

  if (
    !ordenTrabajo?.id_orden_trabajo /* ||
    isLoadingNodosByZona ||
    isRefetchingNodosByZona */
  )
    return null;
  // if (isLoadingNapsByCity || isRefetchingNapsByCity) return null;

  return (
    <>
      {/* <RenderFotosEntradaSalida ordenTrabajo={ordenTrabajo} showFotosEntrada={true}/>
      <RenderFotosEntradaSalida ordenTrabajo={ordenTrabajo} showFotosSalida={true}/> */}


      {/* -------- View data servicio ---------- */}
      {/* <FlotaAndServiceActivationInstallPart
        form={form}
        ordenTrabajo={ordenTrabajo}
      /> */}
      {/* <CustomTextFieldNoForm
        label='Flota'
        value={form.getValues()?.flota_data?.nombre || "N/A"}
        disabled
      /> */}

      {/* ------- cliente --------- */}
      {/* <TabTextLabel text="Cliente" pt="42px" /> */}
        {/* ------- view ------- */}
          {/* <CustomTextField
            name="razon_social"
            label="Razón social"
            control={form.control}
            defaultValue={form.getValues()?.prospecto_data?.razon_social || ''}
            error={errors?.prospecto_data?.razon_social}
            helperText={errors?.prospecto_data?.razon_social?.message?.toString() ?? ''}
            shrink={shrink}
            size={gridSizeMdLg6}
            disabled
          />
          <CustomTextField
            name="identificacion"
            label="Razón social"
            control={form.control}
            defaultValue={form.getValues()?.prospecto_data?.identificacion || ''}
            error={errors?.prospecto_data?.identificacion}
            helperText={errors?.prospecto_data?.identificacion?.message?.toString() ?? ''}
            shrink={shrink}
            size={gridSizeMdLg6}
            disabled
          /> */}
          {/* ========== location ========== */}
          {/* <CustomTextField
            name="pais"
            label="País"
            control={form.control}
            defaultValue={form.getValues()?.pais || ''}
            error={errors.pais}
            helperText={errors.pais?.message?.toString() ?? ''}
            shrink={shrink}
            size={gridSizeMdLg6}
            disabled
          />
          <CustomTextField
            name="ciudad"
            label="Ciudad"
            control={form.control}
            defaultValue={form.getValues()?.ciudad || ''}
            error={errors.ciudad}
            helperText={errors.ciudad?.message?.toString() ?? ''}
            shrink={shrink}
            size={gridSizeMdLg6}
            disabled
          />
          <CustomTextField
            name="zona"
            label="Zona"
            control={form.control}
            defaultValue={form.getValues()?.zona || ''}
            error={errors.zona}
            helperText={errors.zona?.message?.toString() ?? ''}
            shrink={shrink}
            size={gridSizeMdLg6}
            disabled
          />
          <CustomTextField
            name="sector"
            label="Sector"
            control={form.control}
            defaultValue={form.getValues()?.sector || ''}
            error={errors.sector}
            helperText={errors.sector?.message?.toString() ?? ''}
            shrink={shrink}
            size={gridSizeMdLg6}
            disabled
          />
          <CustomTextField
            name="direccion"
            label="Dirección"
            control={form.control}
            defaultValue={form.getValues()?.direccion || ''}
            error={errors.direccion}
            helperText={errors.direccion?.message?.toString() ?? ''}
            shrink={shrink}
            disabled
          /> */}

          {/* <Grid item xs={12} container spacing={2} alignItems="center">
            <Grid item xs={12} md={11}>
              <CustomTextField
                type="coordenada"
                control={form.control}
                name="coordenadas"
                defaultValue={form.getValues()?.coordenadas || ''}
                size={gridSize}
                label="Coordenadas del Cliente"
                error={errors.coordenadas}
                startAdornment={
                  <InputAdornment position="start">
                    <SvgIcon fontSize="small">
                      <GlobeEuropeAfricaIcon />
                    </SvgIcon>
                  </InputAdornment>
                }
                helperText={errors.coordenadas?.message}
                onChangeValue={(e, v) => {
                  if (isOnlyView) return;

                  if (v) {
                    let s = e.split(',');
                    setLatLng({ lat: s[0], lng: s[1] });
                    setCurrentCoordenadas(e);
                  }

                  form.reset({
                    ...form.getValues(),
                    nap: '',
                  });
                }}
              />
            </Grid>

            <Grid item xs={12} md={1}>
              <IconBtnModalMapComponent
                coords={
                  `${latLng.lat},${latLng.lng}` ||
                  `${form.getValues().coordenadas}` ||
                  ''
                }
                btnColor="info"
                showCustomMap
                customMap={
                  <Map
                    coordenadas={latLng}
                    napsByCity={napsByCity || []}
                    setLatLng={setLatLng}
                    canDragMarker={!isOnlyView}
                  />
                }
              />
            </Grid>
          </Grid> */}

        {/* ------- edit --------- */}
        
          {/* <TabTextLabel text="ACTIVACIÓN" pt="30px" /> */}
          {
            form.getValues()?.olt_data?.es_bras?
            <CustomAlertCard
            alertColor='info'
            alertTitle="Nota"
            alertMessage={texto.notificacion_es_bras}
            bgColorAlert="GREEN" />
            :
            <CustomAlertCard
            alertColor='info'
            alertTitle="Nota"
            alertMessage={texto.notificacion_es_router} 
            bgColorAlert="SKY"/>
          }

          


          <>
            {/* {isLoadingNodoNaps ? (
              <CustomCircularPorgress />
            ) : ( */}
              <>
                {/* ----------- Change NODO/OLT ----------- */}
                <Grid item container xs={12} alignItems="center" spacing={2}>
                  <Grid item xs={12} md={6}>
                    <CustomAutocomplete<Nodo>
                      label="Nodo"
                      name="nodo"
                      textFieldKey="nombre"
                      valueKey="nombre"
                      actualValueKey="codigo"
                      // options
                      options={nodosByZona?.data?.data || []}
                      defaultValue={form.getValues()?.nodo || ''}
                      isLoadingData={isLoadingNodosByZona}
                      // errors
                      control={form.control}
                      error={errors.nodo!}
                      helperText={errors.nodo?.message}
                      size={gridSize}
                      disabled={!canChangeNodeOLT || isOnlyView}
                      disableClearable
                      onChangeValue={nodoCode => {
                        form.reset({
                          ...form.getValues(),
                          nodo: nodoCode,
                          olt: '',
                          nap: '',
                          router: '',
                          puerto: '',
                          distancia: '',

                          //
                          ipv4_actual: '',
                          ipv6_actual: '',
                          pppoe: '',
                          pppassword: '',
                          actualizar_nodo_olt: true,
                        });
                        setCanChangeNap(true);
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={6} container alignItems="center">
                    <Grid item xs={12} md={11}>
                      <CustomAutocomplete<OLT>
                        label="OLT"
                        name="olt"
                        // options
                        options={oltsPagingRes?.data?.data || []}
                        valueKey="nombre"
                        actualValueKey="codigo"
                        defaultValue={form.getValues()?.olt || ''}
                        isLoadingData={isLoadingOLTs}
                        // validation
                        control={form.control}
                        error={errors.olt}
                        helperText={errors.olt?.message}
                        size={gridSize}
                        disabled={!canChangeNodeOLT || isOnlyView}
                        disableClearable
                        onChangeValue={oltCode => {
                          form.reset({
                            ...form.getValues(),
                            olt: oltCode,
                            nap: '',
                            router: '',
                            puerto: '',
                            distancia: '',

                            //
                            ipv4_actual: '',
                            ipv6_actual: '',
                            pppoe: '',
                            pppassword: '',

                            actualizar_nodo_olt: true,
                          });
                          setCanChangeNap(true);
                        }}
                      />
                    </Grid>

                    <Grid item xs={12} md={1}>
                      <SingleIconButton
                        startIcon={<ChangeCircleIcon />}
                        color={!canChangeNodeOLT ? 'primary' : 'error'}
                        label={
                          canChangeNodeOLT
                            ? 'No permitido cancelar'
                            : 'Cambiar Nodo/OLT'
                        }
                        onClick={() => {
                          if (isOnlyView) return;

                          if (!canChangeNodeOLT) {
                            setConfirmDialog({
                              isOpen: true,
                              title: 'Cambiar Nodo/OLT',
                              subtitle:
                                '¿Está seguro de cambiar Nodo/OLT? Si cambia el Nodo/OLT se perderán los datos de activación, y estos serán calculados nuevamente tras guardar el formulario. Una vez cambiado el Nodo/OLT, no podrá revertirlo a menos que reinicie la página (previo a guardar el formuario). ¿Desea continuar?',
                              onConfirm: () => {
                                setCanChangeNodeOLT(
                                  canChangeNodeOLT ? false : !canChangeNodeOLT
                                );
                                setConfirmDialogIsOpen(false);
                              },
                            });
                          }
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <CustomAutocomplete<Router>
                  label="Router"
                  name="router"
                  textFieldKey="nombre"
                  defaultValue={form.getValues()?.router || ''}
                  // options
                  valueKey="nombre"
                  actualValueKey="codigo"
                  options={routesrPagingRes?.data.data || []}
                  isLoadingData={isLoadingRouters || isRefetchingRouters}
                  disableClearable
                  // errors
                  control={form.control}
                  error={errors.router as any}
                  helperText={errors.router?.message}
                  // size={gridSizeMdLg6}
                />

                {/* ----------- NAP and Port ----------- */}
                <>
                  {/* {isLoadingNodoNaps ? (
                    <Grid
                      item
                      container
                      xs={12}
                      justifyContent="center"
                      alignItems="center"
                      my={2}
                    >
                      <CustomCircularPorgress />
                    </Grid>
                  ) : ( */}
                    <>
                      {/* ---- Nap & Port ---- */}
                      <Grid
                        item
                        container
                        xs={12}
                        alignItems="center"
                        spacing={2}
                      >
                        <Grid item xs={12} md={6}>
                          <CustomAutocomplete<Naps>
                            label="NAP"
                            name="nap"
                            textFieldKey={form.getValues().nap}
                            valueKey="nombre"
                            actualValueKey="codigo"
                            defaultValue={ form.getValues()?.rawNap?.nombre }
                            // options
                            options={napsByCity || []}
                            isLoadingData={isLoadingNapsByCity}
                            // validation
                            control={form.control}
                            error={errors.nap}
                            helperText={errors.nap?.message}
                            size={gridSize}
                            disabled={!canChangeNap || isOnlyView}
                            disableClearable
                            onChangeRawValue={nap => {
                              if (!nap) return;
                              form.reset({
                                ...form.getValues(),
                                rawNap: nap,
                                puerto: '',
                                distancia: nap?.distancia?.toString() || '',
                              });
                            }}
                          />
                        </Grid>

                        <Grid item xs={12} md={6} container alignItems="center">
                          <Grid item xs={12} md={11}>
                            {!canChangeNap ? (
                              <CustomTextFieldNoForm
                                label="Puerto"
                                value={watchedPort || ''}
                                disabled
                                size={gridSize}
                              />
                            ) : (
                              <>
                                <CustomAutocomplete<PuertoNap>
                                  label="Puerto"
                                  name="puerto"
                                  // options
                                  options={
                                    watchedRawNap?.puertos?.filter(
                                      puerto =>
                                        !puerto?.estado ||
                                        puerto?.puerto.toString() ===
                                          ordenTrabajo?.puerto?.toString()
                                    ) as PuertoNap[] || []
                                  }
                                  valueKey="puerto"
                                  actualValueKey="puerto"
                                  defaultValue={
                                    ordenTrabajo?.puerto?.toString() || ''
                                  }
                                  isLoadingData={false}
                                  // validation
                                  control={form.control}
                                  error={errors.puerto}
                                  helperText={errors.puerto?.message}
                                  size={gridSize}
                                  disableClearable
                                />
                              </>
                            )}
                          </Grid>

                          <Grid item xs={12} md={1}>
                            <SingleIconButton
                              startIcon={<ChangeCircleIcon />}
                              color={!canChangeNap ? 'primary' : 'warning'}
                              label={
                                canChangeNap ? 'Cancelar' : 'Cambiar NAP/Puerto'
                              }
                              onClick={() => {
                                // if cancel set puerto to default
                                if (canChangeNap) {
                                  form.reset({
                                    ...form.getValues(),
                                    puerto: ordenTrabajo?.puerto?.toString() || '',
                                    distancia: ordenTrabajo?.distancia || '',
                                    nap: ordenTrabajo?.nap?.toString() || '',
                                    rawNap: ordenTrabajo?.nap_data || {},
                                  });
                                }

                                setCanChangeNap(
                                  canChangeNap ? false : !canChangeNap
                                );
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </>
                  {/* )} */}
                </>

                {/* <CustomNumberTextField
                  label="Distancia a la NAP"
                  name="distancia"
                  ///register={form.register('distancia')}
                  error={errors.distancia}
                  helperText={errors.distancia?.message}
                  shrink={shrink}
                  control={form.control}
                  defaultValue={form.getValues()?.distancia}
                  endAdornment={
                    <InputAdornment position="end">metros</InputAdornment>
                  }
                  disabled
                /> */}

                {/* -------- Activacion Data -------- */}
                <>
                  <CustomTextField
                    label="IPv4"
                    name="ipv4_actual"
                    control={form.control}
                    defaultValue={form.getValues()?.ipv4_actual || ''}
                    error={errors.ipv4_actual}
                    helperText={errors.ipv4_actual?.message}
                    size={gridSizeMdLg12}
                    disabled
                    // disabled={isUpdatingPort || canChangeNodeOLT || isOnlyView}
                  />
                  {/* <CustomTextField
                    label="IPv6"
                    name="ipv6_actual"
                    control={form.control}
                    defaultValue={form.getValues()?.ipv6_actual || ''}
                    error={form.formState.errors.ipv6_actual}
                    helperText={
                      form.formState.errors.ipv6_actual?.message || ''
                    }
                    shrink={true}
                    size={gridSizeMdLg6}
                    disabled={isUpdatingPort || canChangeNodeOLT || isOnlyView}
                  /> */}
                  <CustomTextField
                    label="PPPoE"
                    name="pppoe"
                    control={form.control}
                    defaultValue={form.getValues()?.pppoe || ''}
                    error={errors.pppoe}
                    helperText={errors.pppoe?.message}
                    disabled
                    // size={gridSizeMdLg6}
                    // disabled={isUpdatingPort || canChangeNodeOLT || isOnlyView}
                  />
                  <CustomTextField
                    label="PPPassword"
                    name="pppassword"
                    control={form.control}
                    defaultValue={form.getValues()?.pppassword || ''}
                    error={errors.pppassword}
                    helperText={errors.pppassword?.message}
                    disabled
                    // size={gridSizeMdLg6}
                    // disabled={isUpdatingPort || canChangeNodeOLT || isOnlyView}
                  />
                </>
              </>
            {/* )} */}
          </>

          <CustomTextArea
            label="Observación Activación"
            name="observacion_activacion"
            control={form.control}
            defaultValue={form.getValues()?.observacion_activacion || ''}
            error={errors.observacion_activacion}
            helperText={errors.observacion_activacion?.message}
            required={false}
            disabled={isUpdatingPort || isOnlyView}
          />
    </>
  );
};

export default ActivacionInstaOTActiDataFormTab;








// sdasdasdas


//  {/* ------- edit --------- */}
//  <>
//  <TabTextLabel text="ACTIVACIÓN" pt="42px" />

//  <>
//    {isLoadingNodoNaps ? (
//      <CustomCircularPorgress />
//    ) : (
//      <>
//        {/* ----------- Change NODO/OLT ----------- */}
//        <Grid item container xs={12} alignItems="center" spacing={2}>
//          <Grid item xs={12} md={6}>
//            <CustomAutocomplete<Nodo>
//              label="Nodo"
//              name="nodo"
//              textFieldKey="nombre"
//              valueKey="nombre"
//              actualValueKey="codigo"
//              // options
//              options={nodosByZona?.data?.data || []}
//              defaultValue={form.getValues()?.nodo || ''}
//              isLoadingData={isLoadingNodosByZona}
//              // errors
//              control={form.control}
//              error={errors.nodo!}
//              helperText={errors.nodo?.message}
//              size={gridSize}
//              disabled={!canChangeNodeOLT || isOnlyView}
//              disableClearable
//              onChangeValue={nodoCode => {
//                form.reset({
//                  ...form.getValues(),
//                  nodo: nodoCode,
//                  olt: '',
//                  nap: '',
//                  router: '',
//                  puerto: '',
//                  distancia: '',

//                  //
//                  ipv4_actual: '',
//                  ipv6_actual: '',
//                  pppoe: '',
//                  pppassword: '',
//                  actualizar_nodo_olt: true,
//                });
//                setCanChangeNap(true);
//              }}
//            />
//          </Grid>

//          <Grid item xs={12} md={6} container alignItems="center">
//            <Grid item xs={12} md={11}>
//              <CustomAutocomplete<OLT>
//                label="OLT"
//                name="olt"
//                // options
//                options={oltsPagingRes?.data?.data || []}
//                valueKey="nombre"
//                actualValueKey="codigo"
//                defaultValue={form.getValues()?.olt || ''}
//                isLoadingData={isLoadingOLTs}
//                // validation
//                control={form.control}
//                error={errors.olt}
//                helperText={errors.olt?.message}
//                size={gridSize}
//                disabled={!canChangeNodeOLT || isOnlyView}
//                disableClearable
//                onChangeValue={oltCode => {
//                  form.reset({
//                    ...form.getValues(),
//                    olt: oltCode,
//                    nap: '',
//                    router: '',
//                    puerto: '',
//                    distancia: '',

//                    //
//                    ipv4_actual: '',
//                    ipv6_actual: '',
//                    pppoe: '',
//                    pppassword: '',

//                    actualizar_nodo_olt: true,
//                  });
//                  setCanChangeNap(true);
//                }}
//              />
//            </Grid>

//            <Grid item xs={12} md={1}>
//              <SingleIconButton
//                startIcon={<ChangeCircleIcon />}
//                color={!canChangeNodeOLT ? 'primary' : 'error'}
//                label={
//                  canChangeNodeOLT
//                    ? 'No permitido cancelar'
//                    : 'Cambiar Nodo/OLT'
//                }
//                onClick={() => {
//                  if (isOnlyView) return;

//                  if (!canChangeNodeOLT) {
//                    setConfirmDialog({
//                      isOpen: true,
//                      title: 'Cambiar Nodo/OLT',
//                      subtitle:
//                        '¿Está seguro de cambiar Nodo/OLT? Si cambia el Nodo/OLT se perderán los datos de activación, y estos serán calculados nuevamente tras guardar el formulario. Una vez cambiado el Nodo/OLT, no podrá revertirlo a menos que reinicie la página (previo a guardar el formuario). ¿Desea continuar?',
//                      onConfirm: () => {
//                        setCanChangeNodeOLT(
//                          canChangeNodeOLT ? false : !canChangeNodeOLT
//                        );
//                        setConfirmDialogIsOpen(false);
//                      },
//                    });
//                  }
//                }}
//              />
//            </Grid>
//          </Grid>
//        </Grid>

//        <CustomAutocomplete<Router>
//          label="Router"
//          name="router"
//          textFieldKey="nombre"
//          defaultValue={form.getValues()?.router || ''}
//          // options
//          valueKey="nombre"
//          actualValueKey="codigo"
//          options={routesrPagingRes?.data.data || []}
//          isLoadingData={isLoadingRouters || isRefetchingRouters}
//          disableClearable
//          // errors
//          control={form.control}
//          error={errors.router as any}
//          helperText={errors.router?.message}
//          // size={gridSizeMdLg6}
//        />

//        {/* ----------- NAP and Port ----------- */}
//        <>
//          {isLoadingNodoNaps ? (
//            <Grid
//              item
//              container
//              xs={12}
//              justifyContent="center"
//              alignItems="center"
//              my={2}
//            >
//              <CustomCircularPorgress />
//            </Grid>
//          ) : (
//            <>
//              {/* ---- Nap & Port ---- */}
//              <Grid
//                item
//                container
//                xs={12}
//                alignItems="center"
//                spacing={2}
//              >
//                <Grid item xs={12} md={6}>
//                  <CustomAutocomplete<Naps>
//                    label="NAP"
//                    name="nap"
//                    textFieldKey={form.getValues().nap}
//                    valueKey="nombre"
//                    actualValueKey="codigo"
//                    defaultValue={ form.getValues()?.rawNap?.nombre }
//                    // options
//                    options={napsByCity || []}
//                    isLoadingData={isLoadingNapsByCity}
//                    // validation
//                    control={form.control}
//                    error={errors.nap}
//                    helperText={errors.nap?.message}
//                    size={gridSize}
//                    disabled={!canChangeNap || isOnlyView}
//                    disableClearable
//                    onChangeRawValue={nap => {
//                      if (!nap) return;
//                      form.reset({
//                        ...form.getValues(),
//                        rawNap: nap,
//                        puerto: '',
//                        distancia: nap?.distancia?.toString() || '',
//                      });
//                    }}
//                  />
//                </Grid>

//                <Grid item xs={12} md={6} container alignItems="center">
//                  <Grid item xs={12} md={11}>
//                    {!canChangeNap ? (
//                      <CustomTextFieldNoForm
//                        label="Puerto"
//                        value={watchedPort || ''}
//                        disabled
//                        size={gridSize}
//                      />
//                    ) : (
//                      <>
//                        <CustomAutocomplete<PuertoNap>
//                          label="Puerto"
//                          name="puerto"
//                          // options
//                          options={
//                            watchedRawNap?.puertos?.filter(
//                              puerto =>
//                                !puerto?.estado ||
//                                puerto?.puerto.toString() ===
//                                  ordenTrabajo?.puerto?.toString()
//                            ) || []
//                          }
//                          valueKey="puerto"
//                          actualValueKey="puerto"
//                          defaultValue={
//                            ordenTrabajo?.puerto?.toString() || ''
//                          }
//                          isLoadingData={false}
//                          // validation
//                          control={form.control}
//                          error={errors.puerto}
//                          helperText={errors.puerto?.message}
//                          size={gridSize}
//                          disableClearable
//                        />
//                      </>
//                    )}
//                  </Grid>

//                  <Grid item xs={12} md={1}>
//                    <SingleIconButton
//                      startIcon={<ChangeCircleIcon />}
//                      color={!canChangeNap ? 'primary' : 'warning'}
//                      label={
//                        canChangeNap ? 'Cancelar' : 'Cambiar NAP/Puerto'
//                      }
//                      onClick={() => {
//                        // if cancel set puerto to default
//                        if (canChangeNap) {
//                          form.reset({
//                            ...form.getValues(),
//                            puerto: ordenTrabajo?.puerto?.toString() || '',
//                            distancia: ordenTrabajo?.distancia || '',
//                            nap: ordenTrabajo?.nap?.toString() || '',
//                            rawNap: ordenTrabajo?.nap_data || {},
//                          });
//                        }

//                        setCanChangeNap(
//                          canChangeNap ? false : !canChangeNap
//                        );
//                      }}
//                    />
//                  </Grid>
//                </Grid>
//              </Grid>
//            </>
//          )}
//        </>

//        {/* <CustomNumberTextField
//          label="Distancia a la NAP"
//          name="distancia"
//          ///register={form.register('distancia')}
//          error={errors.distancia}
//          helperText={errors.distancia?.message}
//          shrink={shrink}
//          control={form.control}
//          defaultValue={form.getValues()?.distancia}
//          endAdornment={
//            <InputAdornment position="end">metros</InputAdornment>
//          }
//          disabled
//        /> */}

//        {/* -------- Activacion Data -------- */}
//        <>
//          <CustomTextField
//            label="IPv4"
//            name="ipv4_actual"
//            control={form.control}
//            defaultValue={form.getValues()?.ipv4_actual || ''}
//            error={errors.ipv4_actual}
//            helperText={errors.ipv4_actual?.message}
//            size={gridSizeMdLg6}
//            disabled={isUpdatingPort || canChangeNodeOLT || isOnlyView}
//          />
//          <CustomTextField
//            label="IPv6"
//            name="ipv6_actual"
//            control={form.control}
//            defaultValue={form.getValues()?.ipv6_actual || ''}
//            error={form.formState.errors.ipv6_actual}
//            helperText={
//              form.formState.errors.ipv6_actual?.message || ''
//            }
//            shrink={true}
//            size={gridSizeMdLg6}
//            disabled={isUpdatingPort || canChangeNodeOLT || isOnlyView}
//          />
//          <CustomTextField
//            label="PPPoE"
//            name="pppoe"
//            control={form.control}
//            defaultValue={form.getValues()?.pppoe || ''}
//            error={errors.pppoe}
//            helperText={errors.pppoe?.message}
//            // size={gridSizeMdLg6}
//            disabled={isUpdatingPort || canChangeNodeOLT || isOnlyView}
//          />
//          <CustomTextField
//            label="PPPassword"
//            name="pppassword"
//            control={form.control}
//            defaultValue={form.getValues()?.pppassword || ''}
//            error={errors.pppassword}
//            helperText={errors.pppassword?.message}
//            // size={gridSizeMdLg6}
//            disabled={isUpdatingPort || canChangeNodeOLT || isOnlyView}
//          />
//        </>
//      </>
//    )}
//  </>